import { Contrast } from 'lucide-react';
import type { ReactElement } from 'react';

import { AppSidebar } from 'src/components/app-sidebar';
import { Button } from 'src/components/ui/button';
import { Separator } from 'src/components/ui/separator';
import { SidebarProvider, SidebarTrigger } from 'src/components/ui/sidebar';
import { usePreferences } from 'src/hooks/usePreferences';
import { useToolbar } from 'src/hooks/useToolbar';
import { useTheme } from 'src/providers/ThemeProvider';

type BrandSidebarWithHeaderProps = {
  children: ReactElement[] | ReactElement;
  footer?: boolean;
  placeholder?: string;
  fullWidth?: boolean;
};

export function BrandSidebarWithHeader({
  children,
}: BrandSidebarWithHeaderProps): ReactElement {
  const { sidebar, setSidebar } = usePreferences();
  const { toolbarTitle } = useToolbar();
  const { theme, setTheme } = useTheme();

  return (
    <SidebarProvider onOpenChange={setSidebar} open={sidebar}>
      <AppSidebar />
      <div className='flex h-screen w-full flex-col overflow-hidden'>
        <div className='flex h-14 shrink-0 items-center gap-2 bg-layout px-5'>
          <div className='flex items-center gap-2 pr-2'>
            <SidebarTrigger className='size-7' />
          </div>
          <Separator className='h-3/5' orientation='vertical' />
          <span className='ml-2 text-nowrap font-medium text-layout-foreground-secondary'>
            {toolbarTitle}
          </span>
          <div className='flex w-full items-center justify-end'>
            <Button
              className='p-2 focus:outline-hidden focus:ring-0 focus:ring-offset-0'
              key={theme}
              onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
              variant='ghost'
            >
              <Contrast className='size-5 text-layout-foreground' />
            </Button>
          </div>
        </div>
        <Separator />
        {children}
      </div>
    </SidebarProvider>
  );
}
